export default "__VITE_ASSET__Dmv8Jd4t__"